// init Isotope
import $ from 'jquery';
import './daterangepicker';
import jQueryBridget from 'jquery-bridget';
import Isotope from 'isotope-layout';

const availableTours = $('#toursList');

if (availableTours) {
	// make Isotope a jQuery plugin
	jQueryBridget('isotope', Isotope, $);

	let $grid = availableTours.isotope({
		itemSelector: '.toursCard',
		layoutMode:   'fitRows',
		getSortData:  {
			name:   '.name',
			number: '.number',
		},
	});

	$grid.on('arrangeComplete', function(event, filteredItems) {
		if (filteredItems.length === 0) {
			$('#emptyResults').removeClass('d-none');
			$('.toursCard').css('display', 'none');
		} else {
			$('#emptyResults').addClass('d-none');
		}
	});

	const locationListElement = document.querySelector('#location-filter');
	const alphabetFilter = document.querySelector('#alphabet-filter');
	const toursList = [...document.getElementsByClassName('toursCard')];
	let innerHtml = '';
	let ausHtml = '';

	$('#location-filter option').each(function() {
		// Add $(this).val() to your list
		if ($(this).val() !== 'newzealand') {
			let selectedClass = ',.' + $(this).val();
			if (ausHtml === '') {
				selectedClass = '.' + $(this).val();
				ausHtml += selectedClass;
			} else {
				ausHtml += selectedClass;
			}
		}
	});

	//Location Filter
	if (locationListElement) {
		locationListElement.addEventListener('change', (event) => {
			innerHtml = '';

			for (let i = 0; i < toursList.length; i++) {
				if (event.target.value !== 'all') {
					let classes = [...toursList[i].classList];
					if (classes.indexOf(event.target.value.trim().toLowerCase()) > -1) {
						let selectedClass = ',.' + event.target.value;
						if (innerHtml === '') {
							selectedClass = '.' + event.target.value;

							innerHtml += selectedClass;
						}
					}
				}
			}
			if (event.target.value === 'all') {
				$grid.isotope({filter: '*'});
			} else if (event.target.value === 'australia' && ausHtml !== '') {
				$grid.isotope({filter: ausHtml});
			} else if (innerHtml !== '') {
				$grid.isotope({filter: innerHtml});
			} else {
				$grid.isotope({filter: 'abcxyz'});
			}

			commonUpComingFilter();
			let startdate = $('#start-date').val(),
					enddate = $('#end-date').val();
			if (startdate !== '' && enddate !== '') {
				$grid.isotope({
					sortBy: 'number', sortAscending: {name: false}, filter: function() {
						let startDate_ddmm = startdate.split('/');
						let endDate_ddmm = enddate.split('/');
						let startDate_tommddyy = startDate_ddmm[1] + '/' + startDate_ddmm[0] + '/' + startDate_ddmm[2];
						let endDate_tommddyy = endDate_ddmm[1] + '/' + endDate_ddmm[0] + '/' + endDate_ddmm[2];

						let tourLocation = $(this).attr('data-id');
						tourLocation = tourLocation.split('   ');
						let selectedLocation = $('#location-filter').val();

						let tourDateLast = $(this).find('.number-date-last').text();
						tourDateLast = new Date(tourDateLast);
						// Set hours to the end of a day to allow showing today's tours
						tourDateLast.setHours(23, 59, 59);

						if (selectedLocation !== 'all' && selectedLocation !== 'australia') {
							return overlappingDates(new Date($(this).find('.number-date').text()),
									tourDateLast, new Date(startDate_tommddyy),
									new Date(endDate_tommddyy)) && (tourLocation.includes(selectedLocation));
						} else if (selectedLocation === 'australia') {
							let isAu = false;
							$('#location-filter option').each(function() {
								if ($(this).val() !== 'newzealand') {
									if (tourLocation.includes($(this).val())) {
										isAu = tourLocation.includes($(this).val());
									}
								}
							});
							return overlappingDates(new Date($(this).find('.number-date').text()),
									tourDateLast, new Date(startDate_tommddyy),
									new Date(endDate_tommddyy)) && isAu;
						} else {
							return overlappingDates(new Date($(this).find('.number-date').text()),
									tourDateLast, new Date(startDate_tommddyy),
									new Date(endDate_tommddyy));
						}

					},
				});
			}
		});

		// For NZ by default we have only NZ selected by default, thus, trigger change event fot the select filter
		locationListElement.dispatchEvent(new Event('change'));
	}

	function commonUpComingFilter() {
		let selectedLocation = $('#alphabet-filter').val();
		if (selectedLocation === 'all') {
			$grid.isotope({
				sortBy: 'number', sortAscending: {name: false}, filter: function() {
					let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
					let currentDate = new Date().toLocaleString('en-US', options, {timeZone: 'Australia/Melbourne'});

					let tourLocation = $(this).attr('data-id');
					tourLocation = tourLocation.split('   ');

					let new_current_date = new Date(currentDate);
					new_current_date = new_current_date.getTime();
					let selectedLocation = $('#location-filter').val();
					let startdate = $('#start-date').val(),
							enddate = $('#end-date').val();
					let startDate_ddmm = startdate.split('/');
					let endDate_ddmm = enddate.split('/');
					let startDate_tommddyy = startDate_ddmm[1] + '/' + startDate_ddmm[0] + '/' + startDate_ddmm[2];
					let endDate_tommddyy = endDate_ddmm[1] + '/' + endDate_ddmm[0] + '/' + endDate_ddmm[2];

					let tourDateLast = $(this).find('.number-date-last').text();
					tourDateLast = new Date(tourDateLast);
					// Set hours to the end of a day to allow showing today's tours
					tourDateLast.setHours(23, 59, 59);

					let new_tour_date_last = tourDateLast.getTime();

					if (startdate !== '' && enddate !== '') {
						if (selectedLocation !== 'all' && selectedLocation !== 'australia') {
							return (new_tour_date_last > new_current_date) &&
									(tourLocation.includes(selectedLocation)) &&
									overlappingDates(new Date($(this).find('.number-date').text()),
											tourDateLast,
											new Date(startDate_tommddyy), new Date(endDate_tommddyy));
						} else if (selectedLocation === 'australia') {
							let isAu = false;
							$('#location-filter option').each(function() {
								if ($(this).val() !== 'newzealand') {
									if (tourLocation.includes($(this).val())) {
										isAu = tourLocation.includes($(this).val());
									}
								}
							});
							return (new_tour_date_last > new_current_date) && isAu &&
									overlappingDates(new Date($(this).find('.number-date').text()),
											tourDateLast,
											new Date(startDate_tommddyy), new Date(endDate_tommddyy));
						} else {
							return new_tour_date_last > new_current_date &&
									overlappingDates(new Date($(this).find('.number-date').text()),
											tourDateLast,
											new Date(startDate_tommddyy), new Date(endDate_tommddyy));
						}
					} else {
						if (selectedLocation !== 'all' && selectedLocation !== 'australia') {
							return (new_tour_date_last > new_current_date) && (tourLocation.includes(selectedLocation));
						} else if (selectedLocation === 'australia') {
							let isAu = false;
							$('#location-filter option').each(function() {
								if ($(this).val() !== 'newzealand') {
									if (tourLocation.includes($(this).val())) {
										isAu = tourLocation.includes($(this).val());
									}
								}
							});
							return (new_tour_date_last > new_current_date) && isAu;
						} else {
							return new_tour_date_last > new_current_date;
						}
					}
				},
			});
		}
	}

	//Sort Filter
	if (alphabetFilter) {
		const alphabetFilterFunction = (element) => {
			let selectedLocation = $('#location-filter').val();
			let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
			let currentDate = new Date().toLocaleString('en-US', options, {timeZone: 'Australia/Melbourne'});

			let tourLocation = $(element).attr('data-id');
			if (tourLocation) {
				tourLocation = tourLocation.split('   ');
			}

			let new_current_date = new Date(currentDate);
			new_current_date = new_current_date.getTime();
			let startdate = $('#start-date').val(),
					enddate = $('#end-date').val();
			let startDate_ddmm = startdate.split('/');
			let endDate_ddmm = enddate.split('/');
			let startDate_tommddyy = startDate_ddmm[1] + '/' + startDate_ddmm[0] + '/' + startDate_ddmm[2];
			let endDate_tommddyy = endDate_ddmm[1] + '/' + endDate_ddmm[0] + '/' + endDate_ddmm[2];

			let tourDateLast = $(element).find('.number-date-last').text();
			tourDateLast = new Date(tourDateLast);
			// Set hours to the end of a day to allow showing today's tours
			tourDateLast.setHours(23, 59, 59);

			let new_tour_date_last = tourDateLast.getTime();

			if (startdate !== '' && enddate !== '') {
				if (selectedLocation !== 'all' && selectedLocation !== 'australia') {
					return (new_tour_date_last > new_current_date) && (tourLocation.includes(selectedLocation)) &&
							overlappingDates(new Date($(element).find('.number-date').text()),
									tourDateLast, new Date(startDate_tommddyy),
									new Date(endDate_tommddyy));
				} else if (selectedLocation === 'australia') {
					let isAu = false;
					$('#location-filter option').each(function() {
						if ($(this).val() !== 'newzealand') {
							if (tourLocation.includes($(this).val())) {
								isAu = tourLocation.includes($(this).val());
							}
						}
					});
					return (new_tour_date_last > new_current_date) && isAu &&
							overlappingDates(new Date($(element).find('.number-date').text()),
									tourDateLast, new Date(startDate_tommddyy),
									new Date(endDate_tommddyy));
				} else {
					return new_tour_date_last > new_current_date &&
							overlappingDates(new Date($(element).find('.number-date').text()),
									tourDateLast, new Date(startDate_tommddyy),
									new Date(endDate_tommddyy));
				}
			} else {
				if (selectedLocation !== 'all' && selectedLocation !== 'australia') {
					return (new_tour_date_last > new_current_date) && (tourLocation.includes(selectedLocation));
				} else if (selectedLocation === 'australia') {
					let isAu = false;
					$('#location-filter option').each(function() {
						if ($(this).val() !== 'newzealand') {
							if (tourLocation.includes($(this).val())) {
								isAu = tourLocation.includes($(this).val());
							}
						}
					});
					return (new_tour_date_last > new_current_date) && isAu;
				} else {
					return new_tour_date_last > new_current_date;
				}
			}
		};

		alphabetFilter.addEventListener('change', (event) => {
			if (event.target.value === 'all') {
				$grid.isotope({
					sortBy: 'number', sortAscending: {name: false},
					filter: function() {
						return alphabetFilterFunction(this);
					},
				});
			} else if (event.target.value === 'az') {
				$grid.isotope({
					sortBy: 'name', sortAscending: {
						name:   true,
						number: false,
					},
					filter: function() {
						return alphabetFilterFunction(this);
					},
				});
			} else if (event.target.value === 'za') {
				$grid.isotope({
					sortBy:        'name',
					sortAscending: {
						name:   false,
						number: false,
					},
					filter:        function() {
						return alphabetFilterFunction(this);
					},
				});
			}
		});
	}

	let dateRangePicker = $('#date');
	dateRangePicker.daterangepicker({
		autoUpdateInput: false,
		locale:          {
			format:      'DD/MM/YYYY',
			cancelLabel: 'Clear',
		},
	}, function(start, end) {
		// Set new placeholder
		$('#date').val(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));

		const startDate = start.format('MM/DD/YYYY');
		const endDate = end.format('MM/DD/YYYY');

		$('#start-date').val(start.format('DD/MM/YYYY'));
		$('#end-date').val(end.format('DD/MM/YYYY'));

		if (startDate && endDate) {
			$grid.isotope({
				sortBy: 'number', sortAscending: {name: false}, filter: function() {
					let tourLocation = $(this).attr('data-id');
					tourLocation = tourLocation.split('   ');
					const selectedLocation = $('#location-filter').val();

					let tourDateLast = $(this).find('.number-date-last').text();
					tourDateLast = new Date(tourDateLast);
					// Set hours to the end of a day to allow showing today's tours
					tourDateLast.setHours(23, 59, 59);

					if (selectedLocation !== 'all' && selectedLocation !== 'australia') {
						return overlappingDates(new Date($(this).find('.number-date').text()),
								tourDateLast, new Date(startDate),
								new Date(endDate)) && (tourLocation.includes(selectedLocation));
					} else if (selectedLocation === 'australia') {
						return overlappingDates(new Date($(this).find('.number-date').text()),
								tourDateLast, new Date(startDate),
								new Date(endDate)) && !(tourLocation.includes(''));
					} else {
						return overlappingDates(new Date($(this).find('.number-date').text()),
								tourDateLast, new Date(startDate),
								new Date(endDate));
					}
				},
			});
		}
	});

	dateRangePicker.on('cancel.daterangepicker', function() {
		clearFilters(false);
	});

	const clearAllFilters = document.getElementsByClassName('clear-all-filters');

	if (clearAllFilters) {
		for (let n = 0; n < clearAllFilters.length; n++) {
			clearAllFilters[n].addEventListener('click', () => {
				clearFilters();
			});
		}
	}

	const clearFilters = (all = true) => {
		if (all) {
			locationListElement.value = 'all';
			alphabetFilter.value = 'all';
		}
		dateRangePicker.val('');
		$('#date').val('');
		$('#start-date').val('');
		$('#end-date').val('');
		dateRangePicker.data('daterangepicker').setStartDate(new Date());
		dateRangePicker.data('daterangepicker').setEndDate(new Date());

		const changeEvent = new Event('change');
		alphabetFilter.dispatchEvent(changeEvent);
	};

	const overlappingDates = (start_1, end_1, start_2, end_2) => {
		return Math.max(start_1, start_2) <= Math.min(end_1, end_2);
	};
}
